import { Component, Input } from '@angular/core';
import { NavigationService } from '../../../services/navigation/navigation.service';

@Component({
  selector: 'app-navigation-back-button',
  templateUrl: './navigation-back-button.component.html',
  styleUrls: ['./navigation-back-button.component.scss'],
})
export class NavigationBackButtonComponent {
  @Input() backToHome: boolean;
  @Input() customBackPath: string;
  @Input() customLabel: string;

  constructor(private navigationService: NavigationService) {}

  public handleClick() {
    if (this.backToHome) {
      return this.navigateToHome();
    } else {
      return this.navigateBack();
    }
  }

  private navigateBack(): void {
    if (this.customBackPath?.length) {
      this.navigationService.redirectToUrl(this.customBackPath);
    } else {
      this.navigationService.back();
    }
  }

  private async navigateToHome() {
    await this.navigationService.navigateToHome();
  }
}
